import React, { useContext, useEffect, useState, useRef } from "react";
import { useTranslation } from 'react-i18next';
import { BreadcrumbContext } from '../../../../components/Breadcrumb';
import { AuthContext } from "../../../../components/FirebaseAuth";
import { CloudFunctions } from "../../../../components/FirebaseAuth/firebase";
import { useNavigate, Navigate } from "react-router-dom";
import Loader from "../../../../components/Loader";
import { Card, CardContent, Alert, Button, Stack, Typography } from "@mui/material";

const DeleteAccount = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { userData } = useContext(AuthContext);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);
    const [inSubmit, setInSubmit] = useState(false);
    const { setBreadcrumb } = useContext(BreadcrumbContext);
    const mountedRef = useRef(true);

    useEffect(() => {
        setBreadcrumb([
            {
                to: "/",
                text: t('common.home'),
                active: false
            },
            {
                to: "/account/"+userData.currentAccount.id+"/",
                text: userData.currentAccount.name,
                active: false
            },
            {
                to: "/account/"+userData.currentAccount.id+"/billing",
                text: t('nav.billing'),
                active: false
            },
            {
                to: null,
                text: t('deleteAccount.title'),
                active: true
            }
        ]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[userData,setBreadcrumb,t]);

    useEffect(() => {
        return () => {
            mountedRef.current = false
        }
    },[]);

    return (
        <>
            {success?(
                <Navigate to="/" replace />
            ):(
                <Card
                    sx={{
                        backgroundColor: (theme) => theme.custom.card,
                        boxShadow: (theme) => theme.custom.cardShadow,
                        border: (theme) => `1px solid ${theme.custom.border}`,
                    }}
                >
                    <CardContent>
                            {error !== null &&
                                <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>
                            }
                            {userData.currentAccount.price > 0 &&
                                <Alert severity="info" sx={{mb: 2}}>
                                    <strong>{t('deleteAccount.doubleChargeTitle')}</strong>
                                    <ul style={{margin: '8px 0', paddingLeft: '20px'}}>
                                        <li>{t('deleteAccount.doubleCharge1')}</li>
                                        <li>{t('deleteAccount.doubleCharge2')}</li>
                                    </ul>
                                    <span>{t('deleteAccount.doubleChargeNote')}</span>
                                </Alert>
                            }
                            <Typography sx={{ mb: 2 }}>{t('deleteAccount.warning')}</Typography>
                            <Typography color="error" sx={{ mb: 2 }}>{t('deleteAccount.confirmQuestion')}</Typography>
                            <Stack direction="row" spacing={1}>
                                <Button variant="contained" color="error" disabled={inSubmit} onClick={() => {
                                    setInSubmit(true);
                                    const cancelSubscription = CloudFunctions.httpsCallable('cancelSubscription');
                                    cancelSubscription({
                                        accountId: userData.currentAccount.id
                                    }).then(res => {
                                        if (!mountedRef.current) return null
                                        setSuccess(true);
                                        setInSubmit(false);
                                    }).catch(err => {
                                        if (!mountedRef.current) return null
                                        setError(err.message);
                                        setInSubmit(false);
                                    })
                                }}>
                                {inSubmit &&
                                    <Loader />
                                }
                                    {t('deleteAccount.confirm')}</Button>
                                <Button variant="contained" color="secondary" onClick={() => navigate("/account/"+userData.currentAccount.id+"/billing")}>{t('deleteAccount.goBack')}</Button>
                            </Stack>
                    </CardContent>
                </Card>
            )}

        </>
    )
}

export default DeleteAccount;
